export const HUB_TOKENS =
  'bostrom15phze6xnvfnpuvvgs2tw58xnnuf872wlz72sv0j2yauh6zwm7cmqqpmc42';

export const HUB_NETWORKS =
  'bostrom1lpn69a74ftv04upfej8f9ay56pe2zyk48vzlk49kp3grysc7u56qq363nr';

export const HUB_CHANNELS =
  'bostrom15tx5z779rdks07sg774ufn8q0a9x993c9uwmr6ycec78z6lfrmkqyjnfge';

export const HUB_PROTOCOLS =
  'bostrom12yqsxh82qy3dz6alnmjhupyk85skgeqznzxv92q99hqtyu7vvdsqgwjgv';

export const HUB_CONTRACTS = {
  HUB_TOKENS,
  HUB_NETWORKS,
  HUB_CHANNELS,
};
